<template>
   <div style="background:#526193;color:white;padding:40px 0px;text-align:center;font-size:14px">
        <div class="bottom-cate">
            <div style="margin-bottom:10px;font-size:16px;font-weight:bold;">{{$t('menu_product')}}</div>
             <div class="left-panel2">
                <div>
                    <div class="panel-title" @click="jump('1')">
                        <span><i class="bi bi-chevron-right"></i> {{$t('menu_product_1')}}</span>
                    </div>
                </div>
            </div>

            <div class="left-panel2">
                <div>
                    <div class="panel-title" @click="jump('2')">
                        <span><i class="bi bi-chevron-right"></i> {{$t('menu_product_2')}}</span>
                        
                    </div>
                </div>
            </div>

            <div class="left-panel2">
                <div class="panel-heading" role="tab" id="heading3">
                    <div class="panel-title" @click="jump('3')"> 
                            <span><i class="bi bi-chevron-right"></i> {{$t('menu_product_3')}}</span>
                    </div>
                </div>
            </div>

            

            

            <div class="left-panel2">
                <div class="panel-heading" role="tab" id="heading7">
                    <div class="panel-title" @click="jump('4')">
                        <span><i class="bi bi-chevron-right"></i> {{$t('menu_product_4')}}</span>
                    </div>
                </div>
            
            </div>
            
        </div>
        <div class="container">
            <div>Copyright @ 2022  ADA CHEMICALS</div>
            <div>{{ $t('contact_addr_2') }}</div>
        </div>
   </div>
</template>

<script>
import bus from '../util/bus';
export default {
    created(){
    
    },
    mounted(){
        
    },
    components: {
       
    },
    methods:{
        jump(url){
            $(window).scrollTop(0);
            this.$router.push('category?id='+url);
            
            bus.$emit('changecategory');
        }
    }
};
</script>

<style>
.bottom-cate{
    display:none;
    margin-bottom:20px;
    padding:0px 15px;
    text-align:left;
}

.left-panel2{
    height:40px;
    line-height:40px;
    color:#e1e1e1;
    border-bottom:1px solid #888;
}

@media (max-width:520px){
    .bottom-cate{
        display:block;
    }
}
</style>



// WEBPACK FOOTER //
// bottom.vue?4ce21eea